/**
 * « Le chatteur vient d'écrire à un fan » — UN point d'écoute pour tous les
 * envois (11-10-2026).
 *
 * Ses discussions sont libérées quand il n'a écrit à AUCUN fan depuis 15 min
 * (cf `convex/conversationLocks.ts`, `WRITE_IDLE_MS`). Or on écrit à un fan
 * par une quinzaine de routes — texte, média, cadeau, vocal, sondage, lien de
 * paiement, menu, sticker, GIF, pack du jeu, relais X, brouillon de Cyrano…
 * — et chaque hook n'a pas à s'en souvenir : seul le texte le faisait, et un
 * chatteur qui n'envoyait que des médias aurait été déclaré muet. Le client
 * HTTP signale ici tout POST réussi sur l'une d'elles.
 */

const ROUTE_D_ECRITURE =
  /^\/api\/conversations\/([^/?]+)\/(?:send[^/?]*|resend[^/?]*|relais-twitter|cyrano-draft\/send-now)(?:[/?]|$)/;

/** L'id de la conversation si cette requête écrit à un fan, sinon null. Pur. */
export function conversationEcrite(path: string, methode: string): string | null {
  if (methode.toUpperCase() !== "POST") return null;
  const m = ROUTE_D_ECRITURE.exec(path);
  return m ? decodeURIComponent(m[1]!) : null;
}

type Ecouteur = (conversationId: string) => void;
const ecouteurs = new Set<Ecouteur>();

/** S'abonne aux écritures ; rend la fonction de désabonnement. */
export function surEcritureAuFan(ecouteur: Ecouteur): () => void {
  ecouteurs.add(ecouteur);
  return () => {
    ecouteurs.delete(ecouteur);
  };
}

/** Appelé par le client HTTP après un POST réussi. Un écouteur qui lève ne
 *  casse ni l'envoi ni les autres écouteurs. */
export function signalerRequeteReussie(path: string, methode: string): void {
  const conversationId = conversationEcrite(path, methode);
  if (!conversationId) return;
  for (const e of ecouteurs) {
    try {
      e(conversationId);
    } catch {
      // effet de bord : l'envoi est déjà parti
    }
  }
}
